/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Box, DialogContent, Button, Alert, TextField } from "@mui/material";
import Modal from "../Modal/Modal";
import withStepper from "../Modal/withStepper";
import { addToast as addToastAction } from "../../actions/toasts";

import {
  createProvider as createProviderAction
} from "../../actions/providers";

const initialState = {
  name: "",
  reference_language: "",
};

class AddProviderModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = { ...initialState };
  }

  changeInput(inputName, event) {
    const { value } = event.target;

    this.setState(() => ({ [inputName]: value }), this.validateStep);
  }

  async addProvider() {
    const {
      name,
      reference_language
    } = this.state;

    const { createProvider, addToast } = this.props;

    const ret = await createProvider({
      name,
      reference_language
    });

    if (ret.isSuccess) {
      addToast("success", "Success", "Provider successfully added!");
      this.closeModal();
    } else {
      addToast("error", "Error", "Error while adding Provider. Try again.");
    }
  }

  closeModal() {
    const { closeAddModal } = this.props;

    this.setState(initialState);
    closeAddModal();
  }

  isNameValid() {
    const { name } = this.state;
    return name?.length !== 0;
  }

  isReferenceValid() {
    const { reference_language } = this.state;
    return reference_language?.length !== 0 && /([a-z]{2}[_][A-Z]{2})/g.test(reference_language);
  }

  modalContent() {
    const { name, reference_language } = this.state;
    const { isLastStep, stepperComponent } = this.props;

    const isNameValid = this.isNameValid();
    const isReferenceValid = this.isReferenceValid();

    return (
      <DialogContent sx={{ display: "flex", gap: 3, flexDirection: "column", marginTop: 1, width: "80%", alignItems: "center", alignSelf: "center" }}>
        {stepperComponent}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, width: "100%" }}>
          {!isNameValid && <Alert severity="error">
            Provider name is not valid
          </Alert>}
          <TextField label="Name" inputProps={{ readOnly: isLastStep }} error={!isNameValid} value={name} onChange={e => this.changeInput("name", e)}/>
          {!isReferenceValid && <Alert severity="error">
            {reference_language?.length === 0 ? "Reference Language is not valid" : "Reference Language format is not valid. Use <2letters>_<2LETTERS>"}
          </Alert>}
          <TextField label="Reference language" placeholder="en_GB" inputProps={{ readOnly: isLastStep }} error={!isReferenceValid} value={reference_language} onChange={e => this.changeInput("reference_language", e)}/>
        </Box>
      </DialogContent>
    );
  }

  modalActions() {
    const { currentStep, previousStep, nextStep, isLastStep } = this.props;
    const isNameValid = this.isNameValid();
    const isReferenceValid = this.isReferenceValid();

    return (
      [
        <Button variant="outlined"
          key="cancel"
          onClick={() => {
            this.closeModal();
          }} >
            Cancel
        </Button>,
        currentStep > 0 && <Button variant="outlined"
          key="previous"
          onClick={() => {
            previousStep();
          }}>
            Previous
        </Button>,
        !isLastStep && <Button variant="contained"
          key="next"
          disabled={!isReferenceValid || !isNameValid}
          color="secondary"
          onClick={() => {
            nextStep();
          }}>
            Next
        </Button>,
        isLastStep && <Button variant="contained"
          key="save"
          color="secondary"
          onClick={() => {
            this.addProvider();
          }}>
            Save
        </Button>
      ]
    );
  }

  render() {
    const { modalOpened } = this.props;

    return (
      <Modal
        isOpen={modalOpened}
        closeModal={() => this.closeModal()}
        title="Add provider"
        customModalContent={() => this.modalContent()}
        actions={() => this.modalActions()}
        actionAlign="flex-end"
      >
      </Modal>
    );
  }
}

AddProviderModal.propTypes = {
  modalOpened: PropTypes.bool.isRequired,
  closeAddModal: PropTypes.func.isRequired,

  currentStep: PropTypes.number,
  previousStep: PropTypes.func,
  nextStep: PropTypes.func,
  stepperComponent: PropTypes.object,
  isLastStep: PropTypes.bool,

  createProvider: PropTypes.func.isRequired,
  addToast: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  createProvider: createProviderAction,
  addToast: addToastAction
};

export default connect(null, mapDispatchToProps)(withStepper(
  AddProviderModal, [
    "Set provider information",
    "Sumup"
  ]));
